import React from 'react'
import "./Footer.css"

function Footer() {
    return (
        <>
            <div class="Footer mt-5">



                <div class="text-center center-block">
                    <br />

                    <a href="https://www.facebook.com/aesthetestillsandfilms" target="_blank"><i id="social-fb" class="fa fa-facebook-square fa-3x social"></i></a>
                    <a href="https://www.instagram.com/aesthetestillsandfilms/" target="_blank"><i id="social-gp" class="fa fa-instagram fa-3x social"></i></a>
                    <a href="https://www.behance.net/adeelahmed556" target="_blank"><i id="social-em" class="fa fa-behance fa-3x social"></i></a>
                    <p>All CopyRight Researved By Aesthete Stills and Films @ 2021</p>
                </div>

            </div>

        </>
    )
}

export default Footer
